var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatDiary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ccc;}.cls-2{fill:#ae8fea;}.cls-3{fill:#784ace;}.cls-4{fill:#fff;}.cls-5{fill:#ff4a4a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heat_cycle",
    "data-name": "heat cycle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.82,60.66C30.08,60.66.3,87.44.3,120.48v418.8c0,33.06,29.78,59.83,66.52,59.83H532.46c36.75,0,66.52-26.77,66.52-59.83V120.48c0-33-29.77-59.82-66.52-59.82H66.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.82,60.66C30.08,60.66.3,87.58.3,120.48v89.75H599V120.48c0-32.9-29.77-59.82-66.52-59.82H66.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.91,130.45c0,21.46-20.09,38.86-44.87,38.86s-44.87-17.4-44.87-38.86S83.26,91.58,108,91.58,152.91,109,152.91,130.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108,.83A29.92,29.92,0,0,0,78.12,30.74v89.74a29.92,29.92,0,1,0,59.83,0V30.74A29.91,29.91,0,0,0,108,.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M527.88,130.45c0,21.46-20.09,38.86-44.87,38.86s-44.87-17.4-44.87-38.86S458.23,91.58,483,91.58,527.88,109,527.88,130.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M483,.83c-16.51,0-29.92,12-29.92,29.91v89.74c0,15,13.41,29.92,29.92,29.92s29.91-15,29.91-29.92V30.74C512.92,12.79,499.52.83,483,.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.17,289.73v34.39a16,16,0,0,0,16,16h34.39a16,16,0,0,0,16-16V289.73a16,16,0,0,0-16-16H79.17A16,16,0,0,0,63.17,289.73Zm99.58,0v34.39a16,16,0,0,0,16,16h34.39a16,16,0,0,0,16-16V289.73a16,16,0,0,0-16-16H178.75A16,16,0,0,0,162.75,289.73Zm99.58,0v34.39a16,16,0,0,0,16,16h34.39a16,16,0,0,0,16-16V289.73a16,16,0,0,0-16-16H278.33A16,16,0,0,0,262.33,289.73Zm99.58,0v34.39a16,16,0,0,0,16,16H412.3a16,16,0,0,0,16-16V289.73a16,16,0,0,0-16-16H377.91A16,16,0,0,0,361.91,289.73Zm99.58,0v34.39a16,16,0,0,0,16,16h34.39a16,16,0,0,0,16-16V289.73a16,16,0,0,0-16-16H477.49A16,16,0,0,0,461.49,289.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.17,389.31V423.7a16,16,0,0,0,16,16h34.39a16,16,0,0,0,16-16V389.31a16,16,0,0,0-16-16H79.17A16,16,0,0,0,63.17,389.31Zm99.58,0V423.7a16,16,0,0,0,16,16h34.39a16,16,0,0,0,16-16V389.31a16,16,0,0,0-16-16H178.75A16,16,0,0,0,162.75,389.31Zm99.58,0V423.7a16,16,0,0,0,16,16h34.39a16,16,0,0,0,16-16V389.31a16,16,0,0,0-16-16H278.33A16,16,0,0,0,262.33,389.31Zm99.58,0V423.7a16,16,0,0,0,16,16H412.3a16,16,0,0,0,16-16V389.31a16,16,0,0,0-16-16H377.91A16,16,0,0,0,361.91,389.31Zm99.58,0V423.7a16,16,0,0,0,16,16h34.39a16,16,0,0,0,16-16V389.31a16,16,0,0,0-16-16H477.49A16,16,0,0,0,461.49,389.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.17,488.9v34.38a16,16,0,0,0,16,16h34.39a16,16,0,0,0,16-16V488.9a16,16,0,0,0-16-16H79.17A16,16,0,0,0,63.17,488.9Zm99.58,0v34.38a16,16,0,0,0,16,16h34.39a16,16,0,0,0,16-16V488.9a16,16,0,0,0-16-16H178.75A16,16,0,0,0,162.75,488.9Zm99.58,0v34.38a16,16,0,0,0,16,16h34.39a16,16,0,0,0,16-16V488.9a16,16,0,0,0-16-16H278.33A16,16,0,0,0,262.33,488.9Zm99.58,0v34.38a16,16,0,0,0,16,16H412.3a16,16,0,0,0,16-16V488.9a16,16,0,0,0-16-16H377.91A16,16,0,0,0,361.91,488.9Zm99.58,0v34.38a16,16,0,0,0,16,16h34.39a16,16,0,0,0,16-16V488.9a16,16,0,0,0-16-16H477.49A16,16,0,0,0,461.49,488.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.3,
    y: 197.23,
    width: 598.68,
    height: 36.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 262.33,
    y: 373.31,
    width: 66.39,
    height: 66.39,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 162.75,
    y: 373.31,
    width: 66.39,
    height: 66.39,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 63.17,
    y: 373.31,
    width: 66.39,
    height: 66.39,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 461.49,
    y: 273.73,
    width: 66.39,
    height: 66.39,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 361.91,
    y: 273.73,
    width: 66.39,
    height: 66.39,
    rx: 16
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatDiary);
export default __webpack_public_path__ + "static/media/heat_diary.c99a390d628b5c61cc44cbbc68cdc286.svg";
export { ForwardRef as ReactComponent };